//
// --- Constants ---

const USNumberFormat = new Intl.NumberFormat('en-US');

//
// --- Number Format Functions ---

/**
 * Takes in a number a returns a formatted string using Intl.NumberFormat for en-US locales
 */
export function formatNumber(number: number): string {
  return USNumberFormat.format(number);
}

//
// --- Number Validation Functions ---

/**
 * Given a number in a string format, does it contain only digits.
 */
export function isStringAnInteger(integerString: string): boolean {
  // most reliable way to verify a number is all digits
  return typeof integerString === 'string' && !!integerString.match(/^\d+$/);
}

//
// --- Conversion Functions ---

export function convertStringListToIntegerList(integerStringList: ReadonlyArray<string>): ReadonlyArray<number> {
  return integerStringList && Array.isArray(integerStringList)
    ? integerStringList.filter(isStringAnInteger).map(integerString => parseInt(integerString))
    : [];
}
